module.exports = __webpack_public_path__ + "img/af04ff1.png";